export const COMMON_LANDING_CONSTANTS = {
  TRAVEL_INSURANCE_TAB_ID: "TRAVELINSURANCE",
  TRAVEL_PROTECTION_TAB_ID: "TRAVELPROTECTIONPLAN",
  MULTITRIP_OPTION_ID: "MULTITRIP",
  DEFAULT_SUBTITLE: "Select Country",
  TRAVELLER: "Traveller",
  TRAVELLERS: "Travellers",
  DAY: "Day",
  DAYS: "Days",
  /** scrollY threshold (px) beyond which the sticky header is shown. */
  STICKY_HEADER_SCROLL_THRESHOLD: 340,
} as const;

